var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSize({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1426 10.208V13.958C14.1426 17.083 12.8926 18.333 9.76758 18.333H6.01758C2.89258 18.333 1.64258 17.083 1.64258 13.958V10.208C1.64258 7.08301 2.89258 5.83301 6.01758 5.83301H9.76758C12.8926 5.83301 14.1426 7.08301 14.1426 10.208Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3092 4.87533V7.62533C18.3092 9.91699 17.3926 10.8337 15.1009 10.8337H14.1426V10.2087C14.1426 7.08366 12.8926 5.83366 9.76758 5.83366H9.14258V4.87533C9.14258 2.58366 10.0592 1.66699 12.3509 1.66699H15.1009C17.3926 1.66699 18.3092 2.58366 18.3092 4.87533Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.e69472b8fed073f38fd8633cbb414e85.svg";
export { ForwardRef as ReactComponent };